import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
});

// Retiros
export const retiroAPI = {
  procesar: (datos) => API.post('/retiros/procesar', datos),
  obtenerHistorial: () => API.get('/retiros/historial'),
  obtenerCuentaPrincipal: () => API.get('/retiros/cuenta-principal'),
};

// Interceptor para agregar token a las requests
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const authAPI = {
  register: (datos) => API.post('/auth/register', datos),
  login: (datos) => API.post('/auth/login', datos),
  getGoogleConfig: () => API.get('/auth/google/config'),
  loginWithGoogle: (credential) => API.post('/auth/google/login', { credential }),
  completeGoogleRegistration: (datos) => API.post('/auth/google/complete-registration', datos),
  getPerfil: () => API.get('/auth/perfil'),
  verifyEmail: (token) => API.get(`/auth/verify-email?token=${encodeURIComponent(token)}`),
  resendVerification: (email) => API.post('/auth/resend-verification', { email }),
};

  // Gastos Personales
  export const gastosAPI = {
    registrarTransaccion: (datos) => API.post('/transactions', datos),
    obtenerTransacciones: () => API.get('/transactions'),
    definirPresupuesto: (datos) => API.post('/budget', datos),
    obtenerPresupuesto: () => API.get('/budget'),
    obtenerReportes: (params) => API.get('/reports', { params }),
  };
// Transfers
export const transferAPI = {
  realizar: (datos) => API.post('/transferencias/realizar', datos),
  transferenciaBancaria: (datos) => API.post('/transferencias/bancaria', datos),
  retiroCryptoWallet: (datos) => API.post('/transferencias/retiro-crypto', datos),
  obtenerHistorial: () => API.get('/transferencias/historial'),
  obtenerEnviadas: () => API.get('/transferencias/enviadas'),
  obtenerRecibidas: () => API.get('/transferencias/recibidas'),
};

// Loans
export const loanAPI = {
  solicitar: (datos) => API.post('/prestamos/solicitar', datos),
  obtenerMios: () => API.get('/prestamos/mis-prestamos'),
  obtenerTodos: () => API.get('/prestamos/todos'),
  aprobar: (datos) => API.post('/prestamos/aprobar', datos),
  rechazar: (datos) => API.post('/prestamos/rechazar', datos),
};

// Depositos (rutas en /recargas en el backend)
export const depositoAPI = {
  crearDepositoStripe: (datos) => API.post('/recargas/crear', datos),
  crearDepositoPayPal: (datos) => API.post('/recargas/crear-paypal', datos),
  capturarDepositoPayPal: (datos) => API.post('/recargas/paypal/capturar', datos),
  procesarDepositoTarjeta: (datos) => API.post('/recargas/procesar-tarjeta', datos),
  procesarDepositoExitoso: (datos) => API.post('/recargas/procesar', datos),
  obtenerDepositos: () => API.get('/recargas/historial'),
  obtenerResumenPayPal: () => API.get('/recargas/resumen-paypal'),
  canjearCodigo: (datos) => API.post('/recargas/canjear-codigo', datos),
  generarCodigos: (datos) => API.post('/recargas/generar-codigos', datos),
};

// Inversiones (trading en vivo)
export const inversionesAPI = {
  comprar: (datos) => API.post('/inversiones/comprar', datos),
  vender: (datos) => API.post('/inversiones/vender', datos),
  obtenerPosiciones: () => API.get('/inversiones/posiciones'),
  obtenerPortfolio: () => API.get('/inversiones/portfolio'),
  buscarActivos: (query, options = {}) => API.get('/inversiones/buscar', { params: { q: query, ...options } }),
  obtenerCotizacion: (symbol) => API.get(`/inversiones/cotizacion/${encodeURIComponent(symbol)}`),
  obtenerPNLActualizado: () => API.get('/inversiones/pnl/actualizado'),
  obtenerComisiones: () => API.get('/inversiones/comisiones'),
  listarPosicionesCriptoWallet: () => API.get('/inversiones/wallet/posiciones-cripto'),
  venderCriptoWallet: (datos) => API.post('/inversiones/wallet/vender-cripto', datos),
};

// Cuentas Bancarias
export const bankAccountAPI = {
  vincularCuenta: (datos) => API.post('/cuentas-bancarias/vincular', datos),
  verificarCuenta: (datos) => API.post('/cuentas-bancarias/verificar', datos),
  listarCuentas: () => API.get('/cuentas-bancarias/listado'),
  obtenerDefault: () => API.get('/cuentas-bancarias/default'),
  establecerDefault: (datos) => API.post('/cuentas-bancarias/default', datos),
  desvincularCuenta: (cuentaId) => API.post('/cuentas-bancarias/desvincular', { cuentaId }),
  recargarDesdeBanco: (datos) => API.post('/cuentas-bancarias/recargar', datos),
  depositarEnAlpaca: (datos) => API.post('/funding/alpaca/depositar', datos),
  obtenerFundingHistorial: (limit = 20) => API.get('/funding/alpaca/historial', { params: { limit } }),
  sincronizarFundingTransfer: (fundingTransferId) => API.post('/funding/alpaca/sincronizar', { fundingTransferId }),
  sincronizarFundingPendientes: () => API.post('/funding/alpaca/sincronizar-pendientes'),
};

// Foro
export const forumAPI = {
  listarTemas: () => API.get('/foro/temas'),
  crearTema: (datos) => API.post('/foro/temas', datos),
  obtenerTema: (temaId) => API.get(`/foro/temas/${temaId}`),
  crearRespuesta: (temaId, datos) => API.post(`/foro/temas/${temaId}/respuestas`, datos),
};

export default API;
